import { createAction } from '@reduxjs/toolkit';
import { TOrderData, TwsOrder } from '../../utils/types';

export const getOrderRequest = createAction('order/GET_REQUEST');
export const getOrderSuccess = createAction<TOrderData, 'order/GET_SUCCESS'>(
    'order/GET_SUCCESS'
);
export const getOrderDetailsSuccess = createAction<
    TwsOrder,
    'order/GET_DETAILS_SUCCESS'
>('order/GET_DETAILS_SUCCESS');
export const getOrderFailed = createAction<string, 'order/GET_FAILED'>(
    'order/GET_FAILED'
);
export const getOrderClear = createAction('order/GET_CLEAR');

export type TGetOrderActions =
    | ReturnType<typeof getOrderRequest>
    | ReturnType<typeof getOrderSuccess>
    | ReturnType<typeof getOrderFailed>
    | ReturnType<typeof getOrderClear>
    | ReturnType<typeof getOrderDetailsSuccess>;
